export enum AttributeEditorMode {
  Preview,
  Application,
  PersonDetails,
  TeamDetails,
}
